import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class MedicalRecordRecord extends RecordBase {
  static defaultAttributes = {
    id:                            null,
    religion:                      '',
    medication_in_use:             '',
    health_insurance:              '',
    medical_plan:                  '',
    medical_number:                '',
    additional_information:        '',
    weight:                        '',
    height:                        '',
    rg:                            '',
    profession:                    '',
    marital_status:                '',
    father_name:                   '',
    mother_name:                   '',
    family_contact:                '',
    kinship:                       '',
    naturalness:                   null,
    user:                          null,
    doctor:                        null,
  };

  static _attributeNames = null;
  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`medical_records.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        religion:                      trAttr('religion'),
        medication_in_use:             trAttr('medication_in_use'),
        health_insurance:              trAttr('health_insurance'),
        medical_plan:                  trAttr('medical_plan'),
        medical_number:                trAttr('medical_number'),
        additional_information:        trAttr('additional_information'),
        weight:                        trAttr('weight'),
        height:                        trAttr('height'),
        rg:                            trAttr('rg'),
        profession:                    trAttr('profession'),
        marital_status:                trAttr('marital_status'),
        father_name:                   trAttr('father_name'),
        mother_name:                   trAttr('mother_name'),
        family_contact:                trAttr('family_contact'),
        kinship:                       trAttr('kinship'),
        naturalness:                   trAttr('naturalness'),
        user:                          trAttr('user'),
        doctor:                        trAttr('doctor'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      religion,
      medication_in_use,
      health_insurance,
      medical_plan,
      medical_number,
      additional_information,
      weight,
      height,
      rg,
      profession,
      marital_status,
      father_name,
      mother_name,
      family_contact,
      kinship,
      created_at,
      updated_at,
    } = this.toObject();

    return {
      data:{
        attributes:{
          religion,
          medication_in_use,
          health_insurance,
          medical_plan,
          medical_number,
          additional_information,
          weight,
          height,
          rg,
          profession,
          marital_status,
          father_name,
          mother_name,
          family_contact,
          kinship,
          user_id: dig(this.get('user'), 'id'),
          doctor_id: dig(this.get('doctor'), 'id'),
          naturalness_id: dig(this.get('naturalness'), 'id'),
          created_at,
          updated_at,
          ...attrs
        }
      }
    };

  }
}
